<!-- Modal de Senha Temporária -->
<div *ngIf="isOpen" 
  class="fixed inset-0 z-50 flex items-center justify-center"
  (click)="onBackdropClick($event)">
  
  <!-- Backdrop escuro -->
  <div class="absolute inset-0 bg-black/60"></div>
  
  <!-- Conteúdo do Modal -->
  <div class="relative z-10 w-full max-w-md mx-4 bg-white rounded-2xl shadow-2xl p-8 animate-fade-in"
    (click)="$event.stopPropagation()">
    
    <!-- Ícone -->
    <div class="flex justify-center mb-6">
      <div class="w-16 h-16 bg-westetics-purple-100 rounded-full flex items-center justify-center">
        <svg class="w-8 h-8 text-westetics-purple-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
        </svg>
      </div>
    </div>

    <!-- Título -->
    <h2 class="text-xl font-semibold text-neutral-900 text-center mb-2">
      Criar nova senha
    </h2>
    
    <!-- Descrição -->
    <p class="text-sm text-neutral-600 text-center mb-6">
      Sua senha é temporária. Por favor, crie uma nova senha para continuar.
    </p>

    <!-- Formulário -->
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="space-y-4">
      
      <!-- Campo Nova Senha -->
      <div>
        <label for="newPassword" class="block text-sm font-medium text-neutral-900 mb-2">
          Nova senha
        </label>
        <div class="relative">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg class="h-5 w-5 text-neutral-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="1.5">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </div>
          <input formControlName="newPassword" id="newPassword" name="newPassword"
            [type]="showNewPassword ? 'text' : 'password'" autocomplete="new-password" placeholder="••••••••"
            class="block w-full pl-10 pr-12 py-3 rounded-lg border border-neutral-200 text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-westetics-purple-600 focus:border-transparent transition-all duration-200 bg-white">
          <button type="button" (click)="toggleNewPasswordVisibility()" [attr.aria-pressed]="showNewPassword"
            class="absolute inset-y-0 right-0 pr-3 flex items-center text-neutral-400 hover:text-neutral-600 transition-colors">
            <svg *ngIf="!showNewPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            <svg *ngIf="showNewPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
              <line x1="1" y1="1" x2="23" y2="23"></line>
            </svg>
          </button>
        </div>
      </div>

      <!-- Validações da senha -->
      <div class="space-y-2 text-sm">
        <div class="flex items-center gap-2">
          <div class="w-4 h-4 rounded border flex items-center justify-center transition-colors"
            [ngClass]="passwordValidations.hasMinLength ? 'bg-westetics-purple-600 border-westetics-purple-600' : 'border-neutral-300'">
            <svg *ngIf="passwordValidations.hasMinLength" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <span [ngClass]="passwordValidations.hasMinLength ? 'text-westetics-purple-600' : 'text-neutral-500'">Mínimo 8 caracteres</span>
        </div>
        <div class="flex items-center gap-2">
          <div class="w-4 h-4 rounded border flex items-center justify-center transition-colors"
            [ngClass]="passwordValidations.hasLowercase ? 'bg-westetics-purple-600 border-westetics-purple-600' : 'border-neutral-300'">
            <svg *ngIf="passwordValidations.hasLowercase" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <span [ngClass]="passwordValidations.hasLowercase ? 'text-westetics-purple-600' : 'text-neutral-500'">Caracteres minúsculos (a-z)</span>
        </div>
        <div class="flex items-center gap-2">
          <div class="w-4 h-4 rounded border flex items-center justify-center transition-colors"
            [ngClass]="passwordValidations.hasUppercase ? 'bg-westetics-purple-600 border-westetics-purple-600' : 'border-neutral-300'">
            <svg *ngIf="passwordValidations.hasUppercase" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <span [ngClass]="passwordValidations.hasUppercase ? 'text-westetics-purple-600' : 'text-neutral-500'">Caracteres maiúsculos (A-Z)</span>
        </div>
        <div class="flex items-center gap-2">
          <div class="w-4 h-4 rounded border flex items-center justify-center transition-colors"
            [ngClass]="passwordValidations.hasNumber ? 'bg-westetics-purple-600 border-westetics-purple-600' : 'border-neutral-300'">
            <svg *ngIf="passwordValidations.hasNumber" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <span [ngClass]="passwordValidations.hasNumber ? 'text-westetics-purple-600' : 'text-neutral-500'">Números (0-9)</span>
        </div>
        <div class="flex items-center gap-2">
          <div class="w-4 h-4 rounded border flex items-center justify-center transition-colors"
            [ngClass]="passwordValidations.hasSpecialChar ? 'bg-westetics-purple-600 border-westetics-purple-600' : 'border-neutral-300'">
            <svg *ngIf="passwordValidations.hasSpecialChar" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <span [ngClass]="passwordValidations.hasSpecialChar ? 'text-westetics-purple-600' : 'text-neutral-500'">Caracteres especiais (!&#64;#$%)</span>
        </div>
      </div>

      <!-- Campo Confirmar Senha -->
      <div>
        <label for="confirmPassword" class="block text-sm font-medium text-neutral-900 mb-2">
          Confirmar senha
        </label>
        <div class="relative">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg class="h-5 w-5 text-neutral-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="1.5">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </div>
          <input formControlName="confirmPassword" id="confirmPassword" name="confirmPassword"
            [type]="showConfirmPassword ? 'text' : 'password'" autocomplete="new-password" placeholder="••••••••"
            class="block w-full pl-10 pr-12 py-3 rounded-lg border text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-westetics-purple-600 focus:border-transparent transition-all duration-200 bg-white"
            [ngClass]="passwordForm.get('confirmPassword')?.value && !passwordsMatch() ? 'border-red-500' : 'border-neutral-200'">
          <button type="button" (click)="toggleConfirmPasswordVisibility()" [attr.aria-pressed]="showConfirmPassword"
            class="absolute inset-y-0 right-0 pr-3 flex items-center text-neutral-400 hover:text-neutral-600 transition-colors">
            <svg *ngIf="!showConfirmPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            <svg *ngIf="showConfirmPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
              <line x1="1" y1="1" x2="23" y2="23"></line>
            </svg>
          </button>
        </div>
        <!-- Mensagem de erro senhas não coincidem -->
        <p *ngIf="passwordForm.get('confirmPassword')?.value && !passwordsMatch()" class="mt-1 text-sm text-red-500">
          As senhas não coincidem
        </p>
      </div>

      <!-- Botão Salvar -->
      <button type="submit"
        [disabled]="!canSubmit()"
        class="w-full py-3 px-4 mt-4 rounded-lg font-medium text-white transition-all duration-200 flex items-center justify-center gap-2"
        [ngClass]="canSubmit() ? 'bg-westetics-purple-600 hover:bg-westetics-purple-700' : 'bg-neutral-300 cursor-not-allowed'">
        <span *ngIf="!loading">Salvar</span>
        <span *ngIf="loading" class="flex items-center gap-2">
          <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Salvando...
        </span>
      </button>
    </form>
  </div>
</div>
